import React, { useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import * as SiIcons from "react-icons/si";
import Tooltip from "@mui/material/Tooltip";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../pages/Landing/Home.css";
import "../../data/data.json";

const img: string = require("../../assets/picture.jpg");
const resume: string = require("../../assets/dev-resume.pdf");

const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <div className="section_1" id="section_1">
        <div className="left_part">
          <p>
            Software <span>engineer</span>.
          </p>
        </div>
        <div className="middle_part">
          <h1 className="hello_text" data-aos="fade-up">
            Hi, I am Gerard.
          </h1>
          <p data-aos="fade-up" className="span_word sub_body uppercase">
            Designer / Developer / Fullstack
          </p>
          <br />
          <p className="sub_body" data-aos="fade-up">
            I am a Full Stack Developer; I do UI/UX designs suitable for any
            purpose plus building servers for my apps with various backend
            technologies. I worked on various projects most of which include
            graphical user interfaces, and dealing with databases on the
            backend.
          </p>

          <a href={resume} target="_blank">
            {" "}
            <button className="sub_body blue_button" data-aos="fade-up">
              My résumé{" "}
            </button>
          </a>
        </div>
        <div className="new_icons">
          <div className="flex items-center pt-4">
            {" "}
            <Tooltip title="Linkedin" arrow>
              <a
                href="https://www.linkedin.com/in/gerard-valentin-rutayisire-manzi-b79631234/"
                target="_blank"
                className="grow"
              >
                <FaIcons.FaLinkedin
                  className={`mx-2 cursor-pointer text-[#009dff] text-[20px]`}
                />
              </a>
            </Tooltip>{" "}
            <Tooltip title="Github" arrow>
              <a
                href="https://github.com/gerard1001"
                target="_blank"
                className="grow"
              >
                <FaIcons.FaGithub
                  className={`mx-2 cursor-pointer text-[#009dff] text-[20px]`}
                />
              </a>
            </Tooltip>
            <Tooltip title="Discord" arrow>
              <a
                href="https://discord.com/users/1071075450710933616"
                target="_blank"
                className="grow"
              >
                <SiIcons.SiDiscord
                  className={`mx-2 cursor-pointer text-[#009dff] text-[20px]`}
                />
              </a>
            </Tooltip>
            <Tooltip title="Telegram" arrow>
              <a
                href="https://t.me/gerard_manzi"
                target="_blank"
                className="grow"
              >
                <FaIcons.FaTelegramPlane
                  className={`mx-2 cursor-pointer text-[#009dff] text-[20px]`}
                />
              </a>
            </Tooltip>
          </div>
        </div>
        <div className="right_part sub_body">
          <img src={img} alt="" />
        </div>
      </div>
    </>
  );
};

export default Home;
